import { getRoot } from "mobx-state-tree"

export const categoriesFactoryViews = self => ({

})